import React from "react";
import styled from "styled-components";
import GridRow from "./BlogRows/GridRow";
import { Loading } from "../Loading";


const Style= styled.div`
    display: flex;
    flex-direction: column;
    position: relative;
    margin: 1rem 0;
    padding: 0 70px;
    justify-content: center;
    @media screen and (max-width: 850px){
        padding: 0 20px;
        width: calc(100% - 40px);
    }

`

const LotusBlog = (props) => {
    const {blogs} = props;
    const switchs=()=>{
        let temp = [...blogs];
        let types= {}
        if(!blogs){
            return <Style><Loading/></Style>
        }
        for (let i = 0; i < temp.length; i++) {
            const type = temp[i];
            let temp2 = [];
            if(types[type.BType_Id]){
                temp2 = types[type.BType_Id]
            }
            temp2.push(type);
            types[type.BType_Id] = temp2
        }
        let all = Object.keys(types)
        return all.map((key , index)=>{
            let type = types[key]
            return <GridRow {...props} data={type} type={key} key={index}/>
        })
    }
    return(
        <Style>
            {switchs()}
        </Style>
    )
}
export default LotusBlog;